module.exports = "<div style=\"display: inline-block; position: relative;\"><div [class]=\"visible ? 'control-hint-bubble show ' + direction : 'control-hint-bubble'\" (click)=\"toggle()\" [innerHTML]=\"safeHint\"></div><i class=\"fa fa-question-circle\" (click)=\"toggle()\"></i></div>"


//////////////////
// WEBPACK FOOTER
// ./app/common/forms/control-hint.component.html
// module id = 1114
// module chunks = 4